import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    flex: 1;
    display: flex;
    justify-content: center;

    background: ${theme.palette.neutral[50]};
    padding: ${theme.layout.spacing(4)};

    main {
      display: flex;
      flex-direction: column;
      width: 100%;
      flex: 1;

      section {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: ${theme.layout.spacing(2)};
        gap: ${theme.layout.spacing(2)};
      }
    }

    @media (min-width: ${theme.layout.breakpoints.md}) {
      main {
        max-width: ${theme.layout.breakpoints.lg};
      }
    }
  `}
`;
